import moment from 'moment'

import { createEmptyProduct, getEnvTimes } from './Product'

export const SPECIAL_PRODUCT_TYPES = [
    {
        label: 'specialProductTypeWarning',
        value: 'warning',
        colour: '#FF0000',
    },
    {
        label: 'specialProductTypeWatch',
        value: 'watch',
        colour: '#FFA500',
    },
    {
        label: 'specialProductTypeSpecialAdvisory',
        value: 'specialAdvisory',
        colour: '#FFFF00',
    },
]

export const getLabelForType = (type) => {
    return SPECIAL_PRODUCT_TYPES.find((specialProduct) => specialProduct.value === type).label
}

export const getColourForType = (type) => {
    return SPECIAL_PRODUCT_TYPES.find((option) => option.value === type)?.colour || '#FF0000'
}

export const createEmptySpecialProduct = (locale = 'en') => {
    const { issueENV } = getEnvTimes()

    return {
        ...createEmptyProduct('specialproduct'),
        startDate: moment(new Date()).set({ hour: issueENV[0] || 16, minute: issueENV[1] || 0 }),
        message: {
            [locale]: '',
        },
        communications: {
            headline: {
                [locale]: '',
            },
            sms: {
                [locale]: '',
            },
        },
    }
}
